import { render, staticRenderFns } from "./TaskDangerInfo.vue?vue&type=template&id=33f83937&"
import script from "./TaskDangerInfo.vue?vue&type=script&lang=js&"
export * from "./TaskDangerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports